import React, { useContext, useEffect, useState } from 'react';
import { IoFastFood } from "react-icons/io5";
import { IoCartOutline } from "react-icons/io5";
import { RiAccountPinBoxLine } from "react-icons/ri";
import { IoIosSearch } from "react-icons/io";
import { dataContext } from '../UserContext';
import { food_items } from '../food';
import { useSelector } from 'react-redux';
import LoginPanel from './LoginPanel';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuth, signOut } from 'firebase/auth';

function Nav() {
  let { input, setInput, cate, setCate, showCart, setShowCart, currentUser, setCurrentUser } = useContext(dataContext);

  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    let newlist = food_items.filter((item) => item.food_name.toLowerCase().includes(input.toLowerCase()));
    setCate(newlist)
  }, [input, setCate]);

  let items = useSelector(state => state.cart);

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      setCurrentUser(null);
      toast.success("Logged out successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Logout failed!");
    }
  };

  return (
    <div className='w-full h-[100px] flex justify-between items-center md:px-8 px-3'>
      <div className='md:h-[60px] h-[40px] bg-white flex justify-center items-center rounded-md shadow-md px-3'>
        <IoFastFood className='md:w-[30px] md:h-[30px] w-[20px] h-[20px] text-orange-400' />
        <span className='text-[20px] px-1 text-red-700 font-semibold'>SnapEats</span>
      </div>

      <form className='w-[40%] md:h-[60px] bg-white flex items-center px-5 gap-5 rounded-md shadow-md md:w-[70%] h-[40px]' onSubmit={(e) => e.preventDefault()}>
        <IoIosSearch className='w-[30px] h-[30px] text-orange-400' />
        <input type='text' placeholder='Search For Your Favourite Food...' className='w-[100%] outline-none text-[13px] md:text-[15px]' onChange={(e) => setInput(e.target.value)} value={input} />
      </form>

      {currentUser ? (
        <div className='relative group'>
          <div className='flex items-center gap-2 cursor-pointer'>
 {currentUser.photoURL && currentUser.photoURL.startsWith('http') ? (
  <img
    src={currentUser.photoURL}
    alt="Profile"
    className='w-8 h-8 rounded-full border border-red-500'
    onError={(e) => { e.target.style.display = 'none'; }}
  />
) : (
  <div className='w-8 h-8 bg-orange-500 text-white flex items-center justify-center rounded-full text-[14px] font-semibold'>
    {currentUser.displayName ? currentUser.displayName[0] : currentUser.email[0]}
  </div>
)}

            <span className='text-orange-500 font-semibold text-[14px]'>
              {currentUser.displayName || currentUser.email.split('@')[0]}
            </span>
          </div>

          {/* Dropdown */}
          <div className='absolute top-12 right-0 bg-white shadow-lg rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50'>
            <button onClick={handleLogout} className='block px-4 py-2 text-sm text-gray-700 hover:bg-orange-100 rounded-md w-full text-left'>
              Logout
            </button>
          </div>
        </div>
      ) : (
        <div className='md:w-[60px] md:h-[60px] w-[40px] h-[40px] bg-white flex justify-center items-center rounded-md shadow-md relative cursor-pointer' onClick={() => setShowLogin(true)}>
          <RiAccountPinBoxLine className='w-[30px] h-[30px] text-orange-400' />
        </div>
      )}

      <div className='md:w-[60px] md:h-[60px] w-[40px] h-[40px] bg-white flex justify-center items-center rounded-md shadow-md relative cursor-pointer' onClick={() => { setShowCart(true) }}>
        <IoCartOutline className='w-[30px] h-[30px] text-orange-400' />
        <span className='absolute top-1 right-2 text-orange-400 font-semibold'>{items.length}</span>
      </div>

      {showLogin && (
        <>
          <div
            className='fixed inset-0 bg-black opacity-40 z-40'
            onClick={() => setShowLogin(false)}
          />
          <LoginPanel setShowLogin={setShowLogin} />
        </>
      )}
    </div>
  )
}

export default Nav;
